import CourseService from '@/services/CourseService'
import UserService from '@/services/UserService'

import { defaultCourseProgress } from '../data/defaultCourseProgress'

const DEFAULT_LANGUAGE = 1 // ENGLISH LANGUAGE BY DEFAULT

export default {
  namespaced: true,

  state: {
    langId: null,
    course: null,
    courseId: null,
    userId: null,
    progress: defaultCourseProgress,
    activeLesson: {},
    activeModule: {}
  },

  getters: {
    getModuleProgress: state => moduleId => state.progress.modules.length
      ? state.progress.modules.find(module => module.id === moduleId) : null,
    currentLanguageId: state => (state.langId === null) ? DEFAULT_LANGUAGE : state.langId,

    currentModule: state => {
      if (state.progress.modules.length) {
        return state.progress.modules[state.progress.currentModule]
      } else {
        return null
      }
    },

    nextLesson: state => (moduleIndex, lessonIndex) => {
      if (!state.progress.modules.length) {
        return null
      }

      const modules = state.progress.modules

      // If lesson is last of a module
      if (lessonIndex === modules[moduleIndex].lessons.length - 1) {
        // If it's last module of course, return same module
        if (moduleIndex === modules.length - 1) {
          return modules[moduleIndex].lessons[lessonIndex]
        // If not, return first lesson of next module
        } else {
          return modules[moduleIndex + 1].lessons[0]
        }
      // If not, just return next lesson in the module
      } else {
        return modules[moduleIndex].lessons[lessonIndex + 1]
      }
    }
  },

  mutations: {
    setCourse (state, course) {
      state.course = course
    },
    setLangId (state, langId) {
      state.langId = langId
    },

    setCourseId (state, courseId) {
      state.courseId = courseId
    },

    setUserId (state, userId) {
      state.userId = userId
    },

    setProgress (state, progress) {
      state.progress = progress
    },

    setActiveLesson (state, activeLesson) {
      state.activeLesson = activeLesson
    },

    setActiveModule (state, activeModule) {
      state.activeModule = activeModule
    }
  },

  actions: {
    get ({ commit }, courseData) {
      const { courseId, langId } = courseData
      return CourseService.getCourse(courseId, langId)
        .then(course => {
          commit('setCourse', course)
          return course
        })
    },

    getProgress ({ commit, state }) {
      return UserService.getCourseProgress(state.courseId)
        .then(course => {
          const progress = JSON.parse(course.userProgress)

          if (course.userProgress != null) {
            const modules = course.modules.map(module => {
              return {
                id: module.id,
                order: module.order,
                status: (module.order < progress.currentModule) ? 'completed'
                  : (module.order === progress.currentModule) ? 'unlocked' : 'locked',
                resources: module.resources,
                lessons: module.lessons,
                lessonsTotal: module.lessons.length,
                nextLesson: (module.order === progress.currentModule) ? module.lessons[progress.currentLesson]
                  : module.lessons[0]
              }
            })
            progress.modules = modules
          }

          commit('setProgress', progress)
          return course.userProgress
        })
        .catch(err => {
          console.log(err)
        })
    },

    setProgress ({ commit, state }, progress) {
      return UserService.setCourseProgress(state.userId, state.courseId, JSON.stringify(progress))
        .then(() => {
          commit('setProgress', progress)
          return progress
        })
        .catch(err => {
          console.log(err)
        })
    },

    deleteProgress ({ commit, state }) {
      return UserService.deleteCourseProgress(state.userId, state.courseId)
        .then(res => {
          commit('setProgress', defaultCourseProgress)
          return res
        })
    },

    setCourseId ({ commit, state }, courseId) {
      commit('setCourseId', courseId)
    },

    setUserId ({ commit, state }, userId) {
      commit('setUserId', userId)
    },
    setLangId ({ commit, state }, langId) {
      commit('setLangId', langId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/course.js